import { ApiError } from './types';

export const getErrorObject = (error: ApiError) => {
  const code = error?.code ?? 500;
  const description = error?.description ?? 'Unexpected error';
  const technicalMessage = error?.technicalMessage ?? 'Unexpected error';

  return {
    code,
    description,
    technicalMessage
  };
};
